import { TabList as MuiTabList, TabListProps as MuiTabListProps } from "@mui/lab";

interface TabListProps extends MuiTabListProps {
  children: React.ReactNode;
}

export const TabListV2: React.FC<TabListProps> = ({ children, ...props }) => {
  return (
    <MuiTabList
      TabIndicatorProps={{
        style: {
          backgroundColor: "#EC0089",
          height: "3px",
          borderRadius: "2px",
        },
      }}
      {...props}
    >
      {children}
    </MuiTabList>
  );
};

export default TabListV2;
